import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as select from '../data/selector'
import ReCAPTCHA from "react-google-recaptcha"
import { Header, Input, Checkbox, Table, Form, Button,Label } from "semantic-ui-react";
import Group_724 from "../../../image/Group_724.png"
import Group_732 from "../../../image/Group_732.png"
import { Formik, Field, Form as FormikForm } from "formik";
import {FormikInputComponent} from "../../../utilities/formUtils";


const CompanyRegistration_three = (props) => {
    const isSaving = useSelector(state => select.isSaving(state,props));
    const onchangehandle = (e,data) =>{
        if(e.target.name=="gstin_no"){
            props.setgstinnoErrorclass("");
            props.setgstinnoErrorMsg("");
            checkgstInvalidation(e.target,data)
        }else if(e.target.name=="currency"){
            console.log("e.target=",e.target)
            props.setselectedCountryCurrency(e.target.value)
            props.setcurrencyErrorclass("");
            props.setcurrencyErrorMsg("");
        }
    }
    const checkgstInvalidation = (target,data) =>{
        let regexStr = new RegExp('[0-9]{2}[a-zA-Z0-9]{10}[1-9A-Za-z]{1}[0-9A-Za-z]{2}'),
        gstin_no = data.value;
        if(gstin_no!="" && !(regexStr.test(gstin_no))){
            props.setgstinnoErrorclass("error");
            props.setgstinnoErrorMsg("Please provide a valid GSTIN Number");
        }
    }
    const gstChkbxChange = (e,data) => {
        props.setgstinChkStat(data.checked)
    }
    useState(()=>{
        if(props.dataByemailId?.data?.gstin_no !=null && props.dataByemailId?.data?.gstin_no != ""){
            props.setgstinChkStat(true)
        }
    })
    return (
        <div style={{display :props.displayparam}}>
            <div className="signUpContentContainer">
                <div className="chat-wrapper">
                    <div className="chat-head">
                        <h4>RealBooks Virtual Assistant</h4>
                    </div>
                    <div className="chat-boxes-wrap">
                        <div className="chat-box-rb">
                            <img src={Group_724} />
                            <p>You are almost there!</p>
                        </div>
                        <div className="chat-box-rb">
                            <img src={Group_724} />
                            <p>If your business is registered under GST, enable the toggle and enter the company's GSTIN</p>
                        </div>
                        <div className="chat-box-user">
                            <p>And in currency?</p>
                            <img src={Group_732} />
                        </div>
                        <div className="chat-box-rb-2">
                            <img src={Group_724} />
                            <p>The currency is auto-populated based on the country selection, it acts as the base currency for transactions & reporting.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="signUpFormContainer">
                <div className="signUpFormHelpContainerInner gstMarkChkbox">{/*signUpBigFormContainerInnerWidth*/}
                    <div className="sign-up-head">
                        <h3 className="signuptxt">Company Registration</h3>
                    </div>
                    <div className="progress-container">
                        <div className="progress" id="progress"></div>
                        <div className="circle green"></div>
                        <div className="circle green"></div>
                        <div className="circle green"></div>
                        <div className="circle green"></div>
                        <div className="circle active"></div>
                        <div className="circle"></div>
                    </div>
                    <div className="sign-up-form-info">
                    <Form.Group widths={2}>
                            <div className="mb-3">
                                <label for="Inputemail" className="sign-up-field-nameNotImp form-label">Is this business registered under GST?
                                    <Checkbox className="enableGSTChkbox" toggle
                                        checked = {props.gstinChkStat}
                                        onChange={gstChkbxChange}
                                    />
                                </label>
                            </div>
                        </Form.Group>
                        {
                            props.gstinChkStat ? 
                            <>
                            <Form.Group widths={2}>
                                <div className="mb-3">
                                    <Field
                                        id="gstin_no"
                                        name="gstin_no"
                                        noLabel="y"
                                        component={FormikInputComponent}
                                        icontoShow = 'credit card outline'
                                        iconPosition='left'
                                        placeholder = "Enter the GST number"
                                        style={{marginTop:"11px"}}
                                        className={props.gstinnoErrorclass}
                                        myChangeFunction = {onchangehandle}
                                        iserror={props.gstinnoErrorclass != "" ? true : false}
                                        customErrorMsg = {props.gstinnoErrorMsg}
                                    />
                                </div>
                                </Form.Group>
                            </>
                            :
                            ""
                        }
                        <Form.Group widths={2}>
                                <div className="mb-3 mb-4">
                                    {/* {console.log("=======>>>>>"+props.selectedCountryCurrency)} */}
                                    <label for="Inputemail" className="sign-up-field-name form-label">Currency</label>
                                    <Field
                                        id="currency"
                                        name="currency"
                                        noLabel="y"
                                        disabled
                                        component={FormikInputComponent}
                                        icontoShow = 'currency'
                                        iconPosition='left'
                                        placeholder = "Currency is auto populated"
                                        style={{marginTop:"11px",opacity:"0.9"}}
                                        className={props.currencyErrorclass}
                                        myChangeFunction = {onchangehandle}
                                        iserror={props.currencyErrorclass != "" ? true : false}
                                        customErrorMsg = {props.currencyErrorMsg}
                                        userProps={{"value":props.selectedCountryCurrency}}
                                    />
                                </div>
                            </Form.Group>
                        <Form.Group widths={2}>
                            <div style={{height: "20px"}}></div>
                        </Form.Group>
                        <br/>
                        <Form.Group widths={2}>
                            <Button
                                floated="left"
                                type="button"
                                size="medium"
                                // color="green"
                                className="btn-back"
                                onClick={props.clickBackBtn}
                                style={{ width: "94%", marginTop: "10px" }}
                            >Back</Button>
                            <Button
                                floated="left"
                                type="submit"
                                size="medium"
                                color="green"
                                className="btn-next"
                                // disabled = {isSaving ? true : false}                             
                                // loading = {isSaving ? true : false}  
                                style={{ width: "94%", marginTop: "10px" }}
                            >Next</Button>
                        </Form.Group>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default CompanyRegistration_three;